import { NgModule } from '@angular/core';
import { AutoCompleteComponent } from './autoComplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../appMaterial/app-material.module';

@NgModule({
  imports: [CommonModule, AppMaterialModule, FormsModule, ReactiveFormsModule, FlexLayoutModule],
  exports: [AutoCompleteComponent],
  declarations: [AutoCompleteComponent],
  providers: []
})
export class AutoCompleteModule {}
